// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__WgKVa","legacyBtn":"MutateMid_legacyBtn__ygCij"};